<template>
  <div class="account">
    <div class="filter">
      <el-form :inline="true">
        <el-form-item label="账号名称：">
          <el-input
            v-model="model.username"
            placeholder="请输入账号名称"
            @change="getData"
            clearable
          />
        </el-form-item>
        <el-form-item label="数据范围：">
          <el-select
            v-model="model.parkIds"
            placeholder="请选择数据范围"
            @change="getData"
            clearable
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="body">
      <div class="handle">
        <el-button
          type="success"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd"
        >
          添 加
        </el-button>
        <el-button type="info" icon="el-icon-refresh-left" @click="handleReset">
          重置
        </el-button>
        <el-button type="danger" icon="el-icon-delete" @click="batchDelete">
          删 除
        </el-button>
      </div>
      <div class="table-container">
        <el-table
          v-loading="tableLoading"
          :data="tableList"
          @selection-change="selectionChange"
          :height="windowHeight"
        >
          <el-table-column type="selection" width="55" />
          <el-table-column label="姓名" prop="nickname" />
          <el-table-column label="角色" prop="dataType">
            <template slot-scope="{ row }">
              <span>{{
                row.dataType == 1
                  ? "门卫"
                  : row.dataType == 2
                  ? "宿管"
                  : row.dataType == 3
                  ? "仓管"
                  : row.dataType == 4
                  ? "管理员"
                  : ""
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="工号" prop="username" />
          <el-table-column label="园区" prop="parkStr" />
          <el-table-column label="备注" prop="remark" />
          <el-table-column label="操作" width="55">
            <template slot-scope="{ row }">
              <i class="el-icon-edit handle-edit" @click="handleEdit(row)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pager">
        <el-pagination
          :current-page="pageData.page"
          :page-sizes="[20, 40, 60, 80, 100]"
          :page-size="pageData.pageSize"
          :total="total"
          @size-change="sizeChange"
          @current-change="currChange"
          layout="total, sizes, prev, pager, next, jumper"
        />
      </div>
    </div>
    <el-dialog :visible.sync="visible" @close="handleCancel">
      <div class="visibleRefuse">
        <div class="title">角色信息录入</div>
        <div class="content">
          <el-form
            :model="form"
            :rules="rules"
            ref="dialogForm"
            :inline="true"
            class="form"
          >
            <el-form-item
              label="姓名："
              label-width="80px"
              class="form_item1"
              prop="nickname1"
            >
              <el-cascader
                ref="deptCascader"
                v-model="form.nickname1"
                placeholder="请选择姓名"
                :props="{
                  value: 'username',
                  emitPath: false,
                  label: 'nickname',
                  children: 'child',
                  expandTrigger: 'hover'
                }"
                :show-all-levels="false"
                :options="userNameList"
                clearable
                filterable
                style="width: 100%"
                @change="changeUserName"
              ></el-cascader>
            </el-form-item>
            <el-form-item
              label="工号："
              label-width="80px"
              class="form_item1 form_item3"
            >
              <el-input v-model="form.username" readonly />
            </el-form-item>

            <el-form-item
              label="角色："
              label-width="80px"
              prop="dataType"
              class="form_item1"
            >
              <el-select
                v-model="form.dataType"
                placeholder="请选择角色"
                style="width: 100%"
              >
                <el-option
                  v-for="item in optionsRoleList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="园区："
              label-width="80px"
              prop="parkList"
              class="form_item1"
            >
              <el-select
                v-model="form.parkList"
                placeholder="请选择园区"
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="备注：" label-width="80px" class="form_item2">
              <el-input
                v-model="form.remark"
                type="textarea"
                :rows="4"
                style="max-width: 100%"
              />
            </el-form-item>
          </el-form>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancel" class="cancel">取 消</el-button>
        <el-button
          class="submit"
          :loading="btnLoading"
          type="primary"
          @click="handleSubmit"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import apis from "@/apis";

export default {
  name: "roleManage",
  data() {
    return {
      tableLoading: false,
      btnLoading: false,
      model: {
        username: "",
        parkIds: ""
      },
      pageData: {
        page: 1,
        pageSize: 20
      },
      options: [],
      optionsRoleList: [],
      tableList: [],
      selection: [],
      total: 0,
      visible: false,
      handleType: "add",
      form: {
        nickname1: "",
        username: "",
        dataType: "",
        parkList: [],
        remark: ""
      },
      rules: {
        username: [{ required: true, message: "请输入账号" }],
        nickname1: [{ required: true, message: "请选择姓名" }],
        dataType: [{ required: true, message: "请选择角色" }],
        parkList: [{ required: true, message: "请选择园区" }]
      },
      windowHeight: 350,
      userNameList: [],
      roleName: ""
    };
  },
  watch: {
    model: function () {
      this.pageData.page = 1;
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.getData();
    this.getOptions();
    this.queryByRole();
    this.userDirectory();
  },
  methods: {
    handleResize() {
      // 使用 window.innerHeight 获取窗口的高度
      this.$nextTick(() => {
        this.windowHeight = window.innerHeight - 280;
      });
    },
    //角色列表
    queryByRole() {
      apis
        .queryByTypeList({
          type: "role"
        })
        .then(res => {
          if (res.code == 200) {
            this.optionsRoleList = res.data;
          }
        });
    },
    // 姓名列表
    userDirectory() {
      apis.userDirectory().then(res => {
        if (res.code == 200) {
          this.userNameList = res.data;
        }
      });
    },
    // 姓名改变
    changeUserName(value) {
      this.$nextTick(() => {
        this.roleName = this.$refs.deptCascader.presentText;
        this.form.username = value;
        console.log(
          3334,
          this.$refs.deptCascader,
          this.$refs.deptCascader.presentText
        );
      });
    },
    //表格选中事件
    selectionChange(v) {
      this.selection = v;
    },
    //重置
    resetForm() {
      this.form = {
        nickname1: "",
        username: "",
        dataType: "",
        parkList: [],
        remark: ""
      };
    },
    // 删除 角色
    batchDelete() {
      const ids = this.selection.map(item => item.id);
      if (!ids.length) {
        return this.$message.warning("请选择需要删除的账号");
      }

      this.$confirm("是否确认删除?")
        .then(() => {
          apis.parkUserDelete({ ids }).then(() => {
            this.$message.success("删除成功!");
            this.getData();
          });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    //显示添加
    handleAdd() {
      this.resetForm();
      this.visible = true;
      this.handleType = "add";
      this.$refs.dialogForm.resetFields();
    },
    //重置
    handleReset() {
      this.model = {
        username: "",
        parkIds: ""
      };
      this.getData();
    },
    // 点击编辑
    handleEdit(row) {
      const { nickname, username, dataType, parkList, remark, id } = row;
      this.roleName = nickname;
      this.form = {
        nickname1: username,
        username,
        dataType,
        parkList,
        remark,
        id
      };
      this.visible = true;
      console.log("this.roleName", this.roleName);
      this.handleType = "edit";
    },
    // 取消添加
    handleCancel() {
      this.visible = false;
      this.$refs.dialogForm.resetFields();
    },
    // 确认添加角色
    handleSubmit() {
      this.$refs.dialogForm.validate().then(valid => {
        if (valid) {
          this.btnLoading = true;
          const json = {
            nickname: this.roleName,
            username: this.form.username,
            dataType: this.form.dataType,
            parkList: this.form.parkList,
            remark: this.form.remark,
            id: this.form.id,
            type: 3
          };
          apis
            .parkUserAddOrUpdate(json)
            .then(() => {
              this.visible = false;
              this.getData();
              this.$message.success("录入成功!");
            })
            .finally(() => (this.btnLoading = false));
        }
      });
    },
    //分页
    sizeChange(value) {
      this.pageData.pageSize = value;
      this.getData();
    },
    //页码变化
    currChange(value) {
      this.pageData.page = value;
      this.getData();
    },
    // 园区列表
    getOptions() {
      apis.parkQueryAll({ type: 1 }).then(({ data }) => {
        this.options = data;
      });
    },
    //列表数据
    getData() {
      this.tableLoading = true;
      
      apis
        .parkUserList({
          ...this.pageData,
          ...this.model,
          type: 3
        })
        .then(({ data, total }) => {
          this.tableList = data;
          this.total = total;
          this.tableLoading = false
        })
        .finally(() => (this.tableLoading = false));
    }
  }
};
</script>

<style lang="scss" scoped>
.account {
  height: calc(100vh - 77px);
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 0px;
    height: 1px;
    background-color: rgba(240, 240, 240, 1);
  }
}
.handle {
  margin-bottom: 15px;
}
.table-container {
  margin-bottom: 20px;
}
.handle-edit {
  cursor: pointer;
}
.pager {
  display: flex;
  justify-content: flex-end;
}

.form {
  ::v-deep {
    .el-form-item__label {
      padding-right: 0;
    }
  }
  width: 100%;
  .form_item {
    width: 100%;
    ::v-deep {
      .el-form-item__content {
        width: calc(50% - 80px);
      }
    }
  }
  .form_item1 {
    width: 45%;
    ::v-deep {
      .el-form-item__content {
        width: calc(100% - 80px);
      }
    }
  }
  .form_item2 {
    width: 100%;
    ::v-deep {
      .el-form-item__content {
        width: calc(100% - 125px);
      }
    }
  }
  .form_item3 {
    ::v-deep {
      .el-input__inner {
        border: 0;
        &::placeholder {
          color: #048afb;
        }
      }
      .el-icon-arrow-up:before {
        content: "";
      }
    }
  }
}
.dialog-footer {
  .cancel {
    border: 1px solid #388654;
    color: #388654;
  }
  .submit {
    background: #388654;
    border: 1px solid #388654;
    color: #fff;
  }
}
.visibleRefuse {
  .title {
    line-height: 11px;
    height: 100%;
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 11px;
    color: #18191e;
    margin-left: 5px;
    margin-top: -30px;
    &::before {
      content: "";
      display: inline-block;
      width: 2px;
      height: 11px;
      background: #388654;
      margin-right: 5px;
    }
  }
  .content {
    padding: 20px 10px 0 10px;
  }
}
</style>
